export default __webpack_public_path__ + "static/media/User.aeb1c4fa.svg";